import { Component, AfterViewInit, Injector, ChangeDetectorRef } from '@angular/core';
import { MatFormField, MatFormFieldControl } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    selector: '[matErrorMessages]',
    template: '{{ error }}'
})
export class ErrorMessagesDirective implements AfterViewInit {
    error = '';
    inputRef: MatFormFieldControl<MatInput>;

    constructor(private _inj: Injector, private cdRef: ChangeDetectorRef) { }

    ngAfterViewInit() {
        let container = this._inj.get(MatFormField);
        this.inputRef = container._control;

        this.inputRef.ngControl.statusChanges.subscribe(this.updateErrors);
        this.inputRef.ngControl.control.updateValueAndValidity();
        this.cdRef.detectChanges();
    }

    private updateErrors = (state: 'VALID' | 'INVALID') => {
        if (state === 'INVALID') {
            let controlErrors = this.inputRef.ngControl.errors;
            const firstError = Object.keys(controlErrors)[0];

            //Default validators
            if (firstError === 'required')
                this.error = 'Campo obrigatório';

            if (firstError === 'maxlength')
                this.error = `Campo deve ter no máximo ${controlErrors.maxlength.requiredLength} dígitos`;

            if (firstError === 'minlength')
                this.error = `Campo deve ter no mínimo ${controlErrors.minlength.requiredLength} dígitos`;

            if (firstError === 'pattern')
                this.error = 'Formato inválido';

            if (firstError === 'emailValidator')
                this.error = 'Email inválido';
        }
    }

}